import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CalculateResult, CalculatorItem, Calculators } from '@product/const';
import { CustomProductActions, OccProductCalculatorsService } from '@product/data-access';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';

@Injectable()
export class ProductCalculatorsEffects {
  load$: Observable<CustomProductActions.LoadCalculatorsSuccess | CustomProductActions.LoadCalculatorsFail> =
    createEffect(() =>
      this.actions$.pipe(
        ofType(CustomProductActions.LOAD_CALCULATORS),
        mergeMap((action: CustomProductActions.LoadCalculators) => {
          const { productCode } = action;

          return this.occProductCalculatorsService.load(productCode).pipe(
            map(({ calculators }: Calculators) => calculators),
            map(
              (calculators: CalculatorItem[]) =>
                new CustomProductActions.LoadCalculatorsSuccess(productCode, calculators),
            ),
            catchError((e: unknown) => of(new CustomProductActions.LoadCalculatorsFail(productCode, e))),
          );
        }),
      ),
    );

  calculate$: Observable<CustomProductActions.CalculateSuccess | CustomProductActions.CalculateFail> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CustomProductActions.CALCULATE),
        switchMap((action: CustomProductActions.Calculate) => {
          const { calculatorCode, productCode, formData } = action.payload;

          return this.occProductCalculatorsService.calculate(calculatorCode, productCode, formData).pipe(
            map((calculators: CalculateResult) => new CustomProductActions.CalculateSuccess(calculators)),
            catchError((e: unknown) => of(new CustomProductActions.CalculateFail(e))),
          );
        }),
      ),
  );

  constructor(
    private actions$: Actions,
    private occProductCalculatorsService: OccProductCalculatorsService,
  ) {}
}
